/** Ported from the design. Two of these carry meaning and must never be reused
 *  decoratively: `cy` is always market-open / the reference, `am` is always the
 *  closed-market off-hours tape. Premium and discount get their own diverging
 *  pair (`up`/`dn`) so session state and direction can never be confused. */
export const K = {
  bg: '#07090f', txt: '#eef2ff', mut: '#9aa3c7', dim: '#7c86ad', faint: '#4b5470',
  cy: '#4de1ff', am: '#ffb84d', up: '#6fe3a1', dn: '#b48cff',
  line: 'rgba(154,163,199,.16)', line2: 'rgba(154,163,199,.25)',
} as const

export const mono = "'Geist Mono',monospace"
export const sans = "'Space Grotesk',sans-serif"

export const WITHHELD_LABEL: Record<string, string> = {
  'no-public-reference': 'withheld · no public reference',
  'illiquid-pool': 'withheld · pool below liquidity floor',
  'liquidity-read-failed': 'withheld · liquidity read failed',
  'reference-too-stale': 'withheld · reference stale beyond tolerance',
}
export const withheldLabel = (w: string) =>
  WITHHELD_LABEL[w] ?? (w.startsWith('read-failed') ? 'withheld · pool read failed' : 'withheld')
